import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import {
  Paper,
  Button,
  DialogTitle,
  DialogContentText,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  CardMedia
} from "@material-ui/core";
import TriStateTextField from "../../components/textfields/tri-state-txtfield/tri-state-txt-field";
import PasswordField from "../../components/textfields/password/password";

import $ from "jquery";

import logo from "../../images/ACS_CP250_Logo.png";


const styles = theme => ({
  mainApp: {
    margin: "5rem"
  },
  paperCls: {
    padding: "0rem .5rem",
    display: "flex",
    flexDirection: "column",
    padding: ".25rem",
    height:"99%",
    alignItems:"center"
  },
  mt1: {
    marginTop: "3rem"
  },
  mt0: {
    marginTop: "1rem"
  },
  mb0: {
    marginBottom: "1rem"
  },
  hasCursor: {
    cursor: "pointer"
  },
  mainLogin: {
    padding: "1.5rem",
    display: "flex",
    justifyContent: "center",
    height: "91%",
    // backgroundColor:'white'
  },
  mb5: {
    marginBottom: ".5rem"
  },
  mt5: {
    marginTop: "2rem"
  },
  padding25: {
    padding: ".5rem"
  },
  bglogo: {
    backgroundImage: `url(${logo})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundColor: "rgba(255, 255, 255, 0.5) !important",
    backgroundBlendMode: "lighten",
    backgroundSize: "auto 100%",
    height: "80vh"
  },
  logo: {
    alignSelf: "center",
    backgroundSize: "contain",
    height: "27rem",
    width: "23rem"
  },
  bgWhite: {
    backgroundColor: "white",
    width: "90%"
  },
  headerStyle: {
    color: "#5d5d5d"
  },
  formArea:{
    width:"50%"
  },
  flexCol:{
    flexDirection:"column",
  },
  dflex:{
    display:"flex",
  }
});

class Login extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
      hasError: false,
      userName: "sysco",
      password: "Welcome",
      modalIsOpen: false
    };
  }

  validateState = () => {
    this.setState(prevState => {
      return {
        hasError: prevState.userName === "" || prevState.password === ""
      };
    });
  };

  handlePasswordChangeEvent = curValue => {
    this.setState({
      password: curValue
    });

    this.validateState();
  };

  handleUserNameChangeEvent = curValue => {
    this.setState({
      userName: curValue
    });

    this.validateState();
  };

  handleClick = () => {
    // this.props.loginEvent(2);
    // return;

    let url = this.state.isProd
      ? "/api/login"
      : "https://localhost:44331/api/login";

    $.ajax({
      type: "POST",
      url: url,
      data: { username: this.state.userName, password: this.state.password },
      success: result => {
        let res = JSON.parse(result);

        console.log(res);

        if (res.isSuccessful) {
          this.props.loginEvent(res.result);
          return;
        }

        this.setState({
          modalIsOpen: true
        });
      },
      error: result => {
        console.error(result);
        this.setState({
          modalIsOpen: true
        });
      }
    });
  };

  handleClose = () => {
    this.setState({
      modalIsOpen: false
    });
  };

  handleOpen = () => {
    this.setState({
      modalIsOpen: true
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainLogin}>
        <div className={classes.bgWhite}>
          <Paper className={[classes.paperCls].join(" ")}>
            <CardMedia className={classes.logo} image={logo} title="ACS" />

            <Typography
              variant="h4"
              gutterBottom
              align="center"
              className={classes.headerStyle}
            >
              Customer Login
            </Typography>
            <div className={[classes.formArea,classes.flexCol, classes.dflex].join(" ")}>
              <TriStateTextField
                className={classes.mt1}
                label="Customer"
                changeEvent={this.handleUserNameChangeEvent}
                margin="normal"
              />

              <PasswordField
                className={classes.mt1}
                label="Password"
                changeEvent={this.handlePasswordChangeEvent}
                value={this.state.password}
              />

              <Button
                disabled={this.state.hasError}
                variant="contained"
                color="primary"
                className={[classes.button, classes.mt1, classes.mb0].join(" ")}
                onClick={this.handleClick}
                size="large"
              >
                Sign In
              </Button>
            </div>
          </Paper>
        </div>
        <Dialog
          maxWidth="sm"
          open={this.state.modalIsOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Login Failure"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              The Customer Name or Password is invalid - please try again.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              variant="contained"
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(Login);
